import { useState } from "react";
import Navbar from './pages/Shared/Navbar';
import ErrorPage from "./pages/Shared/ErrorPage";
import Dashboard from './pages/Shared/Dashboard';
import Campaigns from "./pages/Advertiser/Campaigns";
import Analytics from "./pages/Advertiser/Analytics";
import Search from "./pages/Scout/Search";
import Messages from "./pages/Scout/Messages";
import AdminCampaigns from "./pages/Admin/Campaigns";
import AdminTemplates from "./pages/Admin/Templates";
import AdminPaymentHistory from "./pages/Admin/PaymentHistory";
import Settings from './pages/Shared/Settings';
import AuthRoute from "../components/Shared/AuthRoute";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { getAppearence } from "../hooks/appearance";

import { statratBlack, statratRed, statratGray } from '../config/constants';

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { stripeKey } from "../config/constants";

const stripePromise = loadStripe(stripeKey);

function App() {
    const [appearence, setAppearence] = useState(getAppearence());
    const theme = createTheme({
        palette: {
            mode: appearence,
            primary: { main: statratRed },
            background: { default: appearence === "dark" ? statratBlack : statratGray },
        },
        typography: {
            fontFamily: 'Inter',
        }
    });

    return (
        <Elements stripe={stripePromise}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Navbar appearence={appearence} setAppearence={setAppearence} />}>
                            <Route index element={<Dashboard />} />
                            <Route path="error" element={<ErrorPage />} />

                            <Route path="campaigns" element={<AuthRoute page={<Campaigns />} category={1} />} />
                            <Route path="analytics" element={<AuthRoute page={<Analytics />} category={1} />} />

                            <Route path="search" element={<AuthRoute page={<Search />} category={2} />} />
                            <Route path="messages" element={<AuthRoute page={<Messages />} category={2} />} />

                            <Route path="admin">
                                <Route path="" element={<AuthRoute page={<Dashboard />} category={0} />} />
                                <Route path="campaigns" element={<AuthRoute page={<AdminCampaigns />} category={0} />} />
                                <Route path="templates" element={<AuthRoute page={<AdminTemplates />} category={0} />} />
                                <Route path="payments" element={<AuthRoute page={<AdminPaymentHistory />} category={0} />} />
                            </Route>

                            <Route path="settings">
                                <Route path="" element={<Settings />} />
                                <Route path="profile" element={<Settings startTab={0} />} />
                                <Route path="billing" element={<Settings startTab={1} />} />
                                <Route path="help" element={<Settings startTab={2} />} />
                            </Route>

                            <Route path="*" element={<Navigate to="/" />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </ThemeProvider>
        </Elements>
    );
}

export default App;
